import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OccCheckoutPaymentAdapter} from '@spartacus/checkout/base/occ';
import {PaymentDetails} from '@spartacus/core';
import {Observable} from 'rxjs';
import {DcpCustomConfig} from '../../config/DcpCustomConfig';

@Injectable({
  providedIn: 'root',
})
export class DcpCheckoutPaymentAdapterService extends OccCheckoutPaymentAdapter {

  public createPaymentDetails(
    userId: string,
    cartId: string,
    paymentDetails: PaymentDetails,
  ): Observable<PaymentDetails> {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<PaymentDetails>(
      this.getSetPaymentDetailsEndpoint(userId, cartId, DcpCustomConfig.custom.endpoints.paymentDetails),
      JSON.stringify(paymentDetails),
      {headers},
    );
  }
}
